export default "__VITE_ASSET__BhCFZ8xs__"